
    'use strict';

    import nddUtilsModule from '../nddUtils/nddUtils.module';
    var angular:angular.IAngularStatic =  require('angular');
    export default angular.module('primo-explore.infra', [nddUtilsModule.name]);
    import './dynamicHtml.directive';
    import './autocomplete/autocomplete.controller';
    import './autocomplete/autocomplete.directive';
    import './contenteditable.directive';





// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/infra.module.ts